import { render, staticRenderFns } from "./manipulacoes.vue?vue&type=template&id=2e03383a"
import script from "./manipulacoes.ts?vue&type=script&lang=js&external"
export * from "./manipulacoes.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e03383a')) {
      api.createRecord('2e03383a', component.options)
    } else {
      api.reload('2e03383a', component.options)
    }
    module.hot.accept("./manipulacoes.vue?vue&type=template&id=2e03383a", function () {
      api.rerender('2e03383a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/manipulacoes.vue"
export default component.exports